<template>
    <div class="more-btn">
        <!-- 悬浮的按钮 -->
        <slot name="hoverBtn"></slot>
        <div class=dropdown v-show="visible">
            <!-- 下拉框 -->
            <div class=default-dropdown>
                <slot name="down"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'hoverdown',
    props:{
        visible: {
            type:Boolean,
            default: true
        }
    }
}
</script>

<style lang="scss" scoped>
.more-btn {
    display: inline-block;
    position: relative;
    height: 0px;
    margin-left: 6px;
    z-index: 4;
    &:hover {
        z-index: 5;
        .dropdown {
            visibility: visible;
            z-index: 5;
            .default-dropdown {
                top: 0px;
            }
        }
    }
    .dropdown {
        position: absolute;
        left: -10px;
        top: 48px;
        padding: 10px;
        visibility: hidden;
        overflow: hidden;
        width: 160px;
        .default-dropdown {
            top: -220px;
            left: 0px;
            min-width: 160px;
        }
    }
}
</style>
